// The root route: wires React Aria's links to the router and wraps every screen in the page shell.

import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet, useRouter } from "@tanstack/react-router";
import { RouterProvider } from "react-aria-components";
import { AppShell } from "../features/shell/AppShell";

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
});

function Root() {
  const router = useRouter();
  return (
    <RouterProvider
      navigate={(to, options) => void router.navigate({ to, ...options })}
      useHref={(to) => router.buildLocation({ to }).href}
    >
      <AppShell>
        <Outlet />
      </AppShell>
    </RouterProvider>
  );
}
